<template>
  <div>
    <div class="search">
      <div style="margin-top: 10px;">
        <label title="用户昵称" class="info">客户昵称</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="系统内的注册客户" v-model="searchNickname" @pressEnter="fetch"/>
        <label title="微信号" class="info">客户微信号</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="系统内的注册客户" v-model="searchUsername" @pressEnter="fetch"/>
        <label title="手机号" class="info">客户手机号</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="系统内的注册客户" v-model="searchPhone" @pressEnter="fetch"/>
        <a-button type="primary" @click="fetch">搜索</a-button>
        <a-button type="primary" @click="clear">清空</a-button>
      </div>
    </div>
    <a-button type='primary' htmlType='submit' style="margin:10px 10px 0 10px;" @click="outputExcel">
      导出
    </a-button>
    <a-table :columns="columns"
             :dataSource="data"
             :pagination="pagination"
             :loading="loading"
             @change="handleTableChange"
             class="chatroom-table"
             style="font-size: 12px !important; margin-top: 10px"
    >
      <!--<template slot="bot_nickname" slot-scope="text, record">-->
      <!--<EditableCell :text="text" @change="onCellChange(record.key, 'bot_nickname')">-->
      <!--</EditableCell>-->
      <!--</template>-->
      <template slot="bot_info" slot-scope="text, record">
        <div v-for="bot in text">
          <span> {{ bot.nickname }} </span>
        </div>
      </template>
      <template slot="display_nick" slot-scope="text, record">
        <EditableCell dataIndex="display_nick" :display_nick="record.display_nick" :nickname="record.nickname" :chatroomname="record.chatroomname" @change="onCellChange">
        </EditableCell>
      </template>
      <template slot="tag_list" slot-scope="text, record">
        <!--<TagList v-on:on-add-tag="onAddTag" :oriTagList="text" :closable="true" :newable="true" :chatroomname="record.chatroomname"> </TagList>-->
        <BindTags :categories="categories" :tagList="text" :dataIndex="record.chatroomname" v-on:on-tag-changed="onTagChanged"> </BindTags>
      </template>
      <template slot="level" slot-scope="text, record">
        <LevelSelector :level="record.level" :levels="levels" :chatroomname="record.chatroomname"/>
      </template>
      <template slot="group" slot-scope="text, record">
        <GroupAutoComplete v-on:add-group="onAddGroup" :group="record.group" :groups="groups" :chatroomname="record.chatroomname"/>
      </template>
      <template slot="actions" slot-scope="text, record">
        <div style="display: flex;">
          <ChattingModal :dataIndex="record.chatroomname" :is_to_friend="false"/>
          <a-popconfirm placement="top" okText="确认" cancelText="不不不" @confirm="quitChatroom(record)">
            <template slot="title">
              <p>确认要退出 {{ record.nickname }} ？，所有机器人都会退出！</p>
            </template>
            <a-button style="margin-left: 8px;" type="primary">退出该群 <a-icon type="exclamation-deletea" /></a-button>
          </a-popconfirm>
          <a-button type="primary" @click="showChatroomMember(record)" style="margin-left: 10px;">查看成员</a-button>
        </div>
      </template>
      <template slot="inviter" slot-scope="text, record">
        <div v-for="inviter in text">
          <span> {{ inviter.nickname }}||{{inviter.alias}}</span>
        </div>
      </template>
    </a-table>
    <a-modal
      :title="cmTitle"
      :visible="cmVisible"
      :footer="null"
      @cancel="closeCmModal">
      <a-table :columns="cmColumns" :dataSource="chatroomMember"></a-table>
      <a-button type="primary" @click="getCmExcel">导出列表</a-button>
    </a-modal>
  </div>
</template>

<script>
import EditableCell from './EditableCell'
import TagList from './TagList'
import GroupAutoComplete from './GroupAutoComplete'
import LevelSelector from './LevelSelector'
import BindTags from './BindTags'
import ChattingModal from './ChattingModal'
import '../config/global'
const axios = require('axios')
export default {
  name: 'ChatroomList',
  props: ['searchChatroomNickname', 'searchOwnerNickname', 'searchOwnerUsername', 'selectedTagList', 'groups', 'levels', 'categories'],
  components: {TagList, EditableCell, GroupAutoComplete, LevelSelector, BindTags, ChattingModal},
  created () {
    this.fetch()
    this.fetchBotList()
  },
  data () {
    return {
      searchNickname: '',
      searchPhone: '',
      searchUsername: '',
      getChatroomListUrlPostFix: 'UChatroom/get_chatroom_list',
      getChatroomListExcelUrlPostFix: 'UChatroom/get_chatroom_list_excel',
      getBotListUrlPostFix: 'UBot/get_bot_list',
      quitAllBotUrlPostFix: 'UChatroom/quit_all_bot',
      getChatroomMemberUrl: global.DOMAIN + 'UChatroom/get_chatroom_member',
      getChatroomMemberExcelUrl: global.DOMAIN + 'UChatroom/get_chatroom_member_excel',
      chatroomfilter: this.filter || {},
      order_by: {},
      data: [],
      pagination: {
        hideOnSinglePage: true,
        showTotal: total => `共 ${total} 个群`,
        pageSize: 10,
        current: 1
      },
      loading: false,
      filters: [],
      columns: [{
        title: '机器人昵称',
        width: '130px',
        dataIndex: 'bot_info',
        scopedSlots: { customRender: 'bot_info' },
        filters: []
      }, {
        title: '原群名',
        width: '150px',
        dataIndex: 'nickname'
      }, {
        title: '显示群名',
        width: '150px',
        dataIndex: 'display_nick',
        scopedSlots: { customRender: 'display_nick' }
      }, {
        title: '人数',
        width: '60px',
        dataIndex: 'member_count'
      }, {
        title: '邀请人昵称||别名',
        width: '130px',
        dataIndex: 'inviter',
        scopedSlots: { customRender: 'inviter' },
        filters: []
      }, {
        title: '群主昵称||别名',
        width: '90px',
        align: 'center',
        dataIndex: 'owner_nickname'
      }, {
        title: '群主所在地',
        width: '95px',
        align: 'center',
        dataIndex: 'owner_location'
      }, {
        title: '发言数',
        sorter: true,
        align: 'center',
        width: '110px',
        dataIndex: 'speak_count'
      }, {
        title: '参与度',
        sorter: true,
        align: 'center',
        width: '110px',
        dataIndex: 'invo_count'
      }, {
        title: '人员变动',
        sorter: true,
        align: 'center',
        width: '132px',
        dataIndex: 'memberchange_count'
      }, {
        title: '群等级',
        width: '100px',
        dataIndex: 'level',
        filters: [],
        scopedSlots: { customRender: 'level' }
      }, {
        title: '群分类',
        width: '130px',
        dataIndex: 'group',
        filters: [],
        scopedSlots: { customRender: 'group' }
      }, {
        title: '标签',
        dataIndex: 'tag_list',
        scopedSlots: { customRender: 'tag_list' }
      }, {
        title: '操作',
        scopedSlots: { customRender: 'actions' }
      }],
      chatroomMember: [],
      cmTitle: undefined,
      cmVisible: false,
      choseChatroomname: undefined,
      cmColumns: [
        {
          dataIndex: 'username',
          title: 'username'
        },
        {
          dataIndex: 'nickname',
          title: '昵称'
        },
        {
          dataIndex: 'alias',
          title: '别名'
        }
      ]
    }
  },
  computed: {
    params: function () {
      return {
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
        tag_list: this.tagIDList,
        chatroom_nickname: this.searchChatroomNickname,
        owner_nickname: this.searchOwnerNickname,
        owner_username: this.searchOwnerUsername,
        nickname: this.searchNickname,
        phone: this.searchPhone,
        username: this.searchUsername,
        level: (this.filters.level || []).map(item => parseInt(item)),
        group: (this.filters.group || []).map(item => parseInt(item)),
        bot_username_list: this.filters.bot_info || [],
        order_by: this.order_by
      }
    },
    tagIDList: function () {
      let tagList = []
      this.selectedTagList.forEach((tag) => {
        tagList.push(tag.id)
      })
      return tagList
    },
    getChatroomListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getChatroomListUrlPostFix
    },
    getBotListUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getBotListUrlPostFix
    },
    quitAllBotUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.quitAllBotUrlPostFix
    }
  },
  watch: {
    groups: function (newValue, oldValue) {
      this.columns[10].filters = []
      this.groups.forEach((group) => {
        this.columns[10].filters.push({
          text: group.group_name,
          value: group.id.toString(),
          ...group
        })
      })
    },
    levels: function (newValue, oldValue) {
      this.columns[9].filters = []
      this.levels.forEach((level) => {
        this.columns[9].filters.push({
          text: level.name,
          value: level.value.toString(),
          name: level.name
        })
      })
      console.log('columns', this.columns)
    },
    selectedTagList: function (newValue, oldValue) {
      if (newValue.length === oldValue.length && newValue.length === 0) {
        console.log('selectedTagList null')
      }
    }
  },
  methods: {
    fetchBotList () {
      axios.post(this.getBotListUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.allBotList = data.data.content.bot_list
            this.columns[0].filters = []
            this.allBotList.forEach((item) => {
              this.columns[0].filters.push({
                text: item.nickname,
                value: item.username
              })
            })
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    onCellChange (value, chatroomname, dataIndex) {
      const dataSource = [...this.data]
      const target = dataSource.find(item => item.chatroomname === chatroomname)
      if (target) {
        target[dataIndex] = value
        this.data = dataSource
      }
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      const { columnKey, order } = sorter
      this.order_by = {}
      if (columnKey !== undefined) {
        this.order_by[columnKey] = 'asc'
        if (order === 'descend') {
          this.order_by[columnKey] = 'desc'
        }
      }
      this.filters = filters
      this.fetch()
    },
    fetch () {
      console.log('params:', this.params)
      this.loading = true
      axios.post(this.getChatroomListUrl, {
        token: sessionStorage.token,
        ...this.params
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            const pagination = { ...this.pagination }
            pagination.total = data.data.content.total_count
            let chatroomList = data.data.content.chatroom_list
            let dataList = []
            chatroomList.forEach((chatroom) => {
              let chatroomInfo = chatroom.chatroom_info
              let chatroomExt = chatroom.chatroom_ext
              let chatroomStatis = chatroom.chatroom_statis
              let tagList = chatroom.tag_list
              let botInfo = chatroom.bot_info || []
              let owner = chatroom.owner
              let chatroomname = chatroomInfo.chatroomname
              let memberCount = chatroomInfo.member_count
              let nickname = chatroomInfo.nickname || chatroomInfo.nickname_default
              let avatarUrl = chatroomInfo.avatar_url
              let ownerAlias = owner.alias
              let ownerAvatarUrl = owner.avatar_url
              let ownerNickname = owner.nickname + '||' + owner.alias
              let ownerUsername = owner.username
              let ownerProvince = owner.province || ''
              let ownerCity = owner.city || ''
              let ownerLocation = (ownerProvince + ' ' + ownerCity).trim() || '-'
              let activeCount = chatroomStatis.active_count
              let inCount = chatroomStatis.in_count || 0
              let invoCount = chatroomStatis.invo_count || 0
              console.log(invoCount)
              if (invoCount.length > 6) {
                invoCount = invoCount.substring(0, 6)
              }
              invoCount += '%'
              let outCount = chatroomStatis.out_count || 0
              let memberchangeCount = inCount + '/' + outCount
              let speakCount = chatroomStatis.speak_count || 0
              let level = chatroomExt.level || '-'
              let displayNick = chatroomExt.display_nick
              let group = chatroomExt.group || {group_name: '', id: 0}
              let inviter = chatroom.inviter || []
              dataList.push({
                chatroomname: chatroomname,
                member_count: memberCount,
                nickname: nickname,
                avatar_url: avatarUrl,
                owner_alias: ownerAlias,
                owner_avatar_url: ownerAvatarUrl,
                owner_nickname: ownerNickname,
                owner_username: ownerUsername,
                active_count: activeCount,
                in_count: inCount,
                out_count: outCount,
                invo_count: invoCount,
                memberchange_count: memberchangeCount,
                speak_count: speakCount,
                level: level,
                display_nick: displayNick,
                group: group,
                tag_list: tagList,
                bot_info: botInfo,
                bot_nickname: botInfo.nickname || '-',
                owner_location: ownerLocation,
                inviter: inviter
              })
            })
            this.loading = false
            this.data = dataList
            this.pagination = pagination
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    onAddGroup (group) {
      this.$emit('add-group', group)
    },
    onAddTag (tag) {
      this.$emit('add-tag', tag)
    },
    outputExcel () {
      let baseUrl = global.DOMAIN + global.API_VERSION + this.getChatroomListExcelUrlPostFix + '?'
      for (let key in this.params) {
        const value = this.params[key]
        if (key === 'order_by') {
          for (let orderKey in value) {
            baseUrl += key + '=' + orderKey + ' ' + value[orderKey] + '&'
            break
          }
          continue
        }
        baseUrl += key + '=' + value + '&'
      }
      baseUrl += 'token' + '=' + sessionStorage.token
      console.log('outputExcel', baseUrl)
      window.open(baseUrl, '_blank')
    },
    onTagChanged (chatroomname, newTagList) {
      const target = this.data.find(item => item.chatroomname === chatroomname)
      if (target) {
        target.tag_list = newTagList
      }
    },
    clear () {
      this.searchUsername = ''
      this.searchNickname = ''
      this.searchPhone = ''
      this.search()
    },
    quitChatroom (record) {
      axios.post(this.quitAllBotUrl, {
        chatroomname: record.chatroomname,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.data.bot_info = []
            window.alert('正在退群')
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    showChatroomMember (record) {
      this.axios.post(this.getChatroomMemberUrl, {
        chatroomname: record.chatroomname,
        token: sessionStorage.token
      }).then(res => {
        if (res.data.err_code === 0) {
          this.cmTitle = record.nickname
          this.chatroomMember = res.data.content.result
          this.choseChatroomname = record.chatroomname
          this.cmVisible = true
        }
      })
    },
    closeCmModal () {
      this.cmVisible = false
    },
    getCmExcel () {
      let url = `${this.getChatroomMemberExcelUrl}?chatroomname=${this.choseChatroomname}&token=${sessionStorage.token}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style>
  .ant-table {
    font-size: 12px !important;
  }
</style>
